import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { submitDealsLead } from '../actions/dealsLead';
import type { TDealsLeadFormResultModalStatus } from '../components/DealsLeadFormResultModal';
import { PHONE_MASK } from '../constants/dealsForm';

import { TThunkDispatch } from '../types/redux';

/**
 * Состояние и обработчики полей заявки продукта "Циан Сделки"
 * (номер телефона, регион, согласие) — общие для баннера и модалки
 */
export const useDealsLeadFormFields = (onAfterSubmit?: VoidFunction) => {
  const dispatch = useDispatch<TThunkDispatch>();
  const [phone, setPhone] = useState('');
  const [regionId, setRegionId] = useState<string | number | null>(null);
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);
  const [resultModalStatus, setResultModalStatus] = useState<TDealsLeadFormResultModalStatus | null>(null);

  const handlePhoneChange = useCallback((value: string) => {
    setPhone(value);
  }, []);

  const handleRegionChange = useCallback((value: string | number) => {
    setRegionId(value);
  }, []);

  const handleAgreementChange = useCallback((_e: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
    setIsAgreementChecked(value);
  }, []);

  const handleSubmit = useCallback(() => {
    void dispatch(submitDealsLead({ phone, regionId }));
    onAfterSubmit?.();
    setResultModalStatus(phone ? 'success' : 'error');
  }, [dispatch, onAfterSubmit, phone, regionId]);

  const handleResultModalClose = useCallback(() => {
    setResultModalStatus(null);
  }, []);

  return {
    phoneProps: {
      size: 'M' as const,
      mask: PHONE_MASK,
      placeholder: 'Номер телефона',
      value: phone,
      onChange: handlePhoneChange,
    },
    selectProps: {
      size: 'M' as const,
      placeholder: 'Выберите регион',
      value: regionId ?? undefined,
      onChange: handleRegionChange,
    },
    isAgreementChecked,
    resultModalProps: {
      status: resultModalStatus,
      onClose: handleResultModalClose,
    },
    handleAgreementChange,
    handleSubmit,
  };
};
